import {stringify} from 'query-string'

export const API_ROOT = process.env.NODE_ENV === 'production' ? '/rest-api/' : 'http://localhost:8081/rest-api/';
// export const WS_ROOT = process.env.NODE_ENV === 'production' ? 'http://online-test.biatlon.cz:8080/online-test-web-1.0-SNAPSHOT/ws-api/' : 'http://localhost:8081/ws-api/';
export const WS_ROOT = API_ROOT.replace("rest-api", "ws-api");

export const serialize = (json) => {
	if (json) {
		for (let k in json) {
			if (json.hasOwnProperty(k) && json[k]) {
				if (json[k] instanceof Date) {
					json[k].toJSON = () => {
						return json[k].getFullYear() + "-" + (json[k].getMonth() + 1) + "-" + json[k].getDate()
					}
				}
			}
		}
	}
	return JSON.stringify(json)
}

export const flatten = (filter) => {
	let query = {}
	if (filter) {
		for (let k in filter) {
			if (filter.hasOwnProperty(k) && (filter[k] || filter[k] === 0)) {
				let value = filter[k]
				if (value && value.constructor === Array) {
					for (let j in value) {
						if (value.hasOwnProperty(j)) {
							if (value[j].value) {
								// flatten as sent from multi-select
								value[j] = value[j].value
							}
						}
					}
				}
				query[k] = value
			}
		}
	}
	return query
}

const resolveError = (result, failureType) => {

	if (result && result.result === 'WARNING') {
		return result.message || 'Varování'
	}

	if (!result.error && !result.message) {
		// general failure
		return "Komunikaci se serverem selhala (" + result.message + ", " + failureType + ")"
	}

	return result.message + (result.messageValues ? (' (' + JSON.stringify(result.messageValues) + ')') : '')
}

const callApi = (endpoint, filter, body, method) => {
	const query = flatten(filter)

	const fullUrl = ((endpoint.indexOf(API_ROOT) === -1) ? API_ROOT + endpoint : endpoint)
		+ (query ? '?' + stringify(query) : '')

	const options = {
		method: method || (body ? 'POST' : 'GET'),
		body: body ? (body instanceof FormData ? body : serialize(body)) : undefined,
		headers: {},
		credentials: 'include'
	}
	options['headers']['Pragma'] = 'no-cache'

	if (body) {
		options['headers']['Accept'] = 'application/json'
		if (body instanceof FormData) {
			// header already set (with boundary)
		} else {
			options['headers']['Content-type'] = 'application/json'
		}
	}

	return fetch(fullUrl, options).then(response => {
		return response.json().catch(error => {
			if (response.status >= 500) {
				return Promise.reject({"message": "Interní chyba - " + response.statusText})
			}
			return Promise.reject({"message": "Neplatná odpověď: " + error.message})
		})

	}).then(json => {
		if ((json.result !== 'OK')) {
			return Promise.reject(json)
		}
		return json

	}).catch(error => {
		return Promise.reject(error)
	})
}

export const BACKEND_API = 'BE API'

// export const callApiWithCallback = (endpoint, schema, callback) => {
// 	return callApi(endpoint, schema).then(
// 		response => callback(response, null),
// 		error => callback(null, error)
// 	)
// }

export default store => next => action => {
	const callAPI = action[BACKEND_API]
	if (typeof callAPI === 'undefined') {
		return next(action)
	}

	let {endpoint} = callAPI
	const {types, filter, body = null, silent = false, method = null} = callAPI

	if (typeof endpoint === 'function') {
		endpoint = endpoint(store.getState())
	}

	if (typeof endpoint !== 'string') {
		throw new Error('Specify a string endpoint URL.')
	}
	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected an array of three action types.')
	}
	if (!types.every(type => typeof type === 'string')) {
		throw new Error('Expected action types to be strings.')
	}

	const actionWith = data => {
		const finalAction = Object.assign({}, action, data)
		delete finalAction[BACKEND_API]
		return finalAction
	}

	const [requestType, successType, failureType] = types
	next(actionWith({type: requestType}))

	return callApi(endpoint, filter, body, method).then(
		response => next(actionWith({
			response,
			type: successType,
			success: response.message,
			filter
		})),
		error => next(actionWith({
			type: failureType,
			error: resolveError(error, failureType),
			data: error && error.data ? error.data : null,
			result: error && error.result ? error.result : "ERROR",
			silent,
			filter
		}))
	)
}



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/middleware/backend.js